import { CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { AxiosRequestConfig } from 'axios';
import { LocationQuery } from 'vue-router';
import { Alert, AlertCount } from './alert.interface';

export class AlertService {
   async getAlerts(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<Alert>>>(`/alerts`, {
         params: { ...query },
         cancelable: false,
      } as CustomAxiosRequestConfig);
      return response.data;
   }

   async getAlertCount() {
      const response = await http.get<AlertCount>(`/alert-count`, { cancelable: false } as AxiosRequestConfig);
      return response.data;
   }

   async getAlert() {
      throw Error('Method not implemented');
   }

   async postAlert() {
      throw Error('Method not implemented');
   }

   async putAlert() {
      throw Error('Method not implemented');
   }

   async deleteAlert(alertId: number) {
      return await http.delete(`/alerts/${alertId}`);
   }
}
